export const SortDescending = (props: any) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.12495 13.7109H6.64058V3.35937C6.64058 3.27344 6.57026 3.20312 6.48433 3.20312H5.39058C5.30464 3.20312 5.23433 3.27344 5.23433 3.35937V13.7109H3.74995C3.61909 13.7109 3.54487 13.8633 3.6269 13.9648L5.8144 16.7363C5.82902 16.755 5.84769 16.7701 5.86901 16.7805C5.89033 16.7909 5.91374 16.7963 5.93745 16.7963C5.96117 16.7963 5.98457 16.7909 6.00589 16.7805C6.02721 16.7701 6.04588 16.755 6.0605 16.7363L8.248 13.9648C8.32808 13.8633 8.25581 13.7109 8.12495 13.7109Z"
        fill="currentColor"
      />
      <rect x="8.75" y="5" width="7.91667" height="1.33333" rx="0.2" fill="currentColor" />
      <rect x="10.4166" y="8" width="6.25" height="1.33333" rx="0.2" fill="currentColor" />
      <rect x="11.25" y="11" width="5.41667" height="1.33333" rx="0.2" fill="currentColor" />
      <rect x="12.0834" y="14" width="4.58333" height="1.33333" rx="0.2" fill="currentColor" />
    </svg>
  );
};
